import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ShortenedDurationState } from '../utils/shortened-duration.helper';

@Component({
  selector: 'tablesready-shortened-duration-warning',
  templateUrl: './shortened-duration-warning.component.html',
  standalone: false,
})
export class ShortenedDurationWarningComponent {
  @Input() state: ShortenedDurationState | null = null;
  @Input() confirmed = false;
  @Output() confirmedChange = new EventEmitter<boolean>();

  onConfirmedChange(value: boolean): void {
    this.confirmed = value;
    this.confirmedChange.emit(value);
  }
}
